export default __webpack_public_path__ + "static/media/emptyState_NoData.cd1af65e.svg";